export type IconProps = {
  className?: string;
};

export function RuralIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 435.801 435.801"
      role="img"
      aria-hidden="true"
      fill="currentColor"
    >
      <g>
        <g>
          <path
            d="M1.819,396.259c-4.06,7.729-1.097,17.28,6.629,21.337c7.718,4.073,17.275,1.092,21.337-6.632
			c0.15-0.284,29.592-28.584,176.287-28.584c158.87,0,202.337,39.903,202.525,40.07c3.107,3.23,7.251,4.855,11.4,4.855
			c3.936,0,7.876-1.458,10.942-4.398c6.297-6.053,6.5-16.046,0.468-22.343c-2.514-2.615-16.377-15.625-52.496-27.705
			c3.26-3.275,5.275-7.795,5.275-12.786v-85.255c0,0,6.439,0,14.371,0c7.937,0,9.282-6.332,3.001-14.147l-74.981-93.36
			c-6.261-7.815-16.366-7.76-22.551,0.124l-3.352,4.275c6.835,5.467,9.653,14.584,6.962,22.966
			c-2.768,8.627-10.705,14.528-19.759,14.7l-1.519,0.033l45.52,49.84c5.651,6.201,7.114,15.153,3.732,22.826
			c-3.393,7.668-10.999,12.629-19.373,12.629h-54.867v57.782c-2.986-0.188-5.977-0.381-9.074-0.538v-66.248h63.941
			c4.794,0,9.13-2.828,11.07-7.215c1.935-4.393,1.102-9.501-2.144-13.041l-59.021-64.655l21.561-0.401
			c5.175-0.104,9.715-3.479,11.288-8.399c1.585-4.931-0.137-10.318-4.29-13.398l-26.056-19.388h2.712c0.021,0,0.046,0,0.061,0
			c6.449,0.081,12.162-5.396,12.162-12.093c0-3.177-1.219-6.068-3.225-8.224l-30.361-42.559h2.981c0.02,0,0.035,0,0.061,0
			c6.642-0.229,12.156-5.403,12.156-12.096c0-3.293-1.314-6.279-3.447-8.467l-47.37-62.467c-2.323-3.072-5.736-5.007-9.836-4.786
			c-3.857,0.063-7.45,1.96-9.679,5.111l-43.701,61.778c-2.615,3.689-2.94,8.531-0.871,12.545c1.818,3.507,5.208,5.878,9.054,6.414
			l-32.39,44.935c-2.252,3.121-2.75,7.056-1.627,10.659c5.57,1.074,10.745,4.03,14.812,8.516l3.176,3.808l33.33,41.498l6.177-8.231
			c2.75-3.659,3.184-8.572,1.138-12.665c-2.044-4.101-6.233-6.69-10.813-6.69h-9.859l19-21.899c3.103-3.58,3.832-8.643,1.864-12.949
			c-1.968-4.311-6.264-7.071-11.004-7.071h-12.743L192.7,89.463c2.661-3.682,3.023-8.546,0.954-12.583
			c-1.84-3.603-5.347-6.012-9.305-6.495l20.721-29.292l23.544,31.055h-2.118c-4.534,0-8.683,2.526-10.752,6.556
			c-2.077,4.029-1.721,8.874,0.909,12.562l31.211,43.757h-15.747c-5.209,0-9.841,3.341-11.476,8.294
			c-1.643,4.954,0.079,10.397,4.261,13.518l26.953,20.051l-12.902,0.244c-4.754,0.089-9.014,2.948-10.888,7.317
			c-1.868,4.367-1.025,9.425,2.174,12.939l58.563,64.149h-48.616c-6.683,0-12.096,5.419-12.096,12.096v77.465
			c-5.926-0.143-11.992-0.229-18.248-0.254v-64.587c-1.856,0.487-3.832,0.772-5.949,0.772h-2.275v63.814
			c-3.026,0.01-6.053,0.025-8.99,0.056V274.86c0,0,6.431,0,14.371,0c7.929,0,9.272-6.332,3.001-14.143l-74.986-93.399
			c-6.274-7.823-16.376-7.756-22.556,0.127l-73.06,93.11c-6.178,7.881-4.771,14.274,3.168,14.274H56.93v85.244
			c0,1.792,0.34,3.488,0.82,5.118C16.781,376.074,5.043,390.14,1.819,396.259z M130.297,275.834h21.858v32.113h-21.858V275.834z
			 M130.297,322.237h21.858v29.925c-7.678,0.427-14.937,0.935-21.858,1.508V322.237z M94.162,275.834h21.861v32.113H94.162V275.834z
			 M94.162,322.237h21.861v32.113H94.162V322.237z"
          />
        </g>
      </g>
    </svg>
  );
}
